(() => {
  if (window.EssentialsContextualComplements) return;

  const getCartSectionIds = () => Array.from(document.querySelectorAll('cart-items-component'))
    .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
    .filter(Boolean);

  const addComplement = async (button) => {
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    const card = button.closest('.es-context-card');
    const status = card?.querySelector('[data-es-complement-status]');
    const originalContent = button.innerHTML;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Añadiendo...';
    if (status) status.textContent = '';

    try {
      const sectionIds = getCartSectionIds();
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));

      const addResponse = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      const addedItem = await addResponse.json();
      if (!addResponse.ok || addedItem.status) {
        throw new Error(addedItem.description || 'No se pudo añadir el producto.');
      }

      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: button.dataset.sourceId || 'essentials-contextual-complements',
          data: {
            source: 'essentials-contextual-complements',
            itemCount: cart.item_count,
            variantId,
            sections: addedItem.sections || {}
          }
        }
      }));

      button.textContent = 'Añadido';
      if (status) status.textContent = 'Producto añadido al carrito.';

      if (button.dataset.openCart === 'true') {
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer?.hasAttribute('auto-open') && typeof drawer.showDialog === 'function') {
          drawer.showDialog();
        }
      }

      window.setTimeout(() => {
        if (!button.isConnected) return;
        button.innerHTML = originalContent;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 1800);
    } catch (error) {
      button.textContent = 'Reintentar';
      if (status) status.textContent = error.message || 'No se pudo añadir. Prueba de nuevo.';
      window.setTimeout(() => {
        if (!button.isConnected) return;
        button.innerHTML = originalContent;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 2200);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-es-complement-add]');
    if (!button) return;
    event.preventDefault();
    addComplement(button);
  });

  window.EssentialsContextualComplements = { addComplement };
})();
